"use client";

import React, { useEffect, useRef } from "react";
// import Image from 'next/image';
import gsap from "gsap";
import hairred1 from "../assets/HairReduction/img12.png"
// import IconFile from '/public/assets/icon-file.svg';
// import IconHand from '/public/assets/icon-hand.svg';
// import IconHand02 from '/public/assets/icon-hand-02.svg';
// import EmptyMockup from '/public/assets/mockup.svg';

import GridContainer from "./Grid";

const SectionHero = () => {
  const textHeroRef = useRef(null);
  const mockupLeftRef = useRef(null);
  const mockupRightRef = useRef(null);

  useEffect(() => {
    const textHero = textHeroRef.current;
    const mockupLeft = mockupLeftRef.current;
    const mockupRight = mockupRightRef.current;

    gsap.fromTo(
      textHero,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 1, ease: "power4.out" }
    );

    gsap.fromTo(mockupLeft, { rotate: 0 }, { rotate: -20, duration: 1 });

    gsap.fromTo(mockupRight, { rotate: 0 }, { rotate: 20, duration: 1 });
  }, []);

  return (
    <section className="relative w-full bg-hero bg-no-repeat bg-top  h-section-hero border-t border-t-green-border pt-[70px] overflow-hidden">
      <GridContainer className="flex flex-col items-center">
        <div
          ref={textHeroRef}
          className="w-full max-w-text-hero text-center opacity-0"
        >
           <h1  className="text-xl md:text-4xl mt-14 lg:mt-8 font-bold mb-4 text-gray-800 uppercase">
        Establish credibility, and highlight key services.
      </h1>
      <p className="mb-3 m-2 lg:m-0 text-gray-600">
      Revolutionizing Dermatology & Cosmetology with Advanced Technology</p>
      {/* <button
       
        className="bg-colorPrimary mt-2 cursor-pointer text-white px-6 py-3 rounded-full hover:bg-colorPrimary/90 transition duration-300"
      >
        Explore Our Solutions
      </button> */}
        </div>

        

        <div className="absolute top-[120px] hidden md:flex bottom-0 w-full max-w-mockups-hero  justify-between">
          <img
            ref={mockupLeftRef}
            src={hairred1}
            alt="Empty mockup"
            className="relative top-[18px] left-[53px]  opacity-[0.4]"
          />
          <img
            ref={mockupRightRef}
            src={hairred1}
            alt="Empty mockup"
            className="relative top-[18px] right-[53px] opacity-[0.4]"
          />
        </div>
      </GridContainer>
    </section>
  );
};

export default SectionHero;
